import * as React from 'react';

import {
  Menubar,
  MenubarCheckboxItem,
  MenubarContent,
  MenubarGroup,
  MenubarItem,
  MenubarLabel,
  MenubarMenu,
  MenubarPortal,
  MenubarRadioGroup,
  MenubarRadioItem,
  MenubarSeparator,
  MenubarShortcut,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
  MenubarTrigger,
} from './components/ui/menubar.js';

export function DimeMenubar({ ...props }: Readonly<React.ComponentProps<typeof Menubar>>) {
  return <Menubar {...props} />;
}

export function DimeMenubarMenu({ ...props }: Readonly<React.ComponentProps<typeof MenubarMenu>>) {
  return <MenubarMenu {...props} />;
}

export function DimeMenubarGroup({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarGroup>>) {
  return <MenubarGroup {...props} />;
}

export function DimeMenubarPortal({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarPortal>>) {
  return <MenubarPortal {...props} />;
}

export function DimeMenubarRadioGroup({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarRadioGroup>>) {
  return <MenubarRadioGroup {...props} />;
}

export function DimeMenubarTrigger({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarTrigger>>) {
  return <MenubarTrigger {...props} />;
}

export function DimeMenubarContent({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarContent>>) {
  return <MenubarContent {...props} />;
}

export function DimeMenubarItem({ ...props }: Readonly<React.ComponentProps<typeof MenubarItem>>) {
  return <MenubarItem {...props} />;
}

export function DimeMenubarCheckboxItem({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarCheckboxItem>>) {
  return <MenubarCheckboxItem {...props} />;
}

export function DimeMenubarRadioItem({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarRadioItem>>) {
  return <MenubarRadioItem {...props} />;
}

export function DimeMenubarLabel({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarLabel>>) {
  return <MenubarLabel {...props} />;
}

export function DimeMenubarSeparator({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarSeparator>>) {
  return <MenubarSeparator {...props} />;
}

export function DimeMenubarShortcut({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarShortcut>>) {
  return <MenubarShortcut {...props} />;
}

export function DimeMenubarSub({ ...props }: Readonly<React.ComponentProps<typeof MenubarSub>>) {
  return <MenubarSub {...props} />;
}

export function DimeMenubarSubTrigger({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarSubTrigger>>) {
  return <MenubarSubTrigger {...props} />;
}

export function DimeMenubarSubContent({
  ...props
}: Readonly<React.ComponentProps<typeof MenubarSubContent>>) {
  return <MenubarSubContent {...props} />;
}
